// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3849":"css/app.6838","6254":"css/admin-app.6838"}[chunkId] + ".css";
};